import Admin from "./dashboard";
import React from 'react'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import Reports from './reports'
import Records from './reports_no'
import { useEffect } from "react";
import { getToken } from "../util";

let lentable = JSON.parse(localStorage.getItem('length'));
const routes = [
  {
    type: "collapse",
    name: "ADMIN",
    key: "dashboard",
    icon: <AdminPanelSettingsIcon/>,
    route: "/dashboard",
    component: <Admin />,
  },
  {
    type: "collapse",
    name: "Tables",
    key: "tables",
    route: "/reports",
    icon: <BackupTableIcon/>,
    component: <Reports />,
  },
  {
    type: "collapse",
    name: "New_user" + "(" + `${lentable}` +")",
    key: "tables",
    route: "/Records",
    icon: <BackupTableIcon/>,
    component: <Records />,
  },

];

export default routes;
